module.exports = __webpack_public_path__ + "3393e98a8c5ef315554f4b1cf4728cd5.png";